import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
function LegalModal({
  type,
  onClose
}: {
  type: 'privacy' | 'terms';
  onClose: () => void;
}) {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" onClick={onClose} data-id="element-94">
      <motion.div initial={{
      scale: 0.9,
      opacity: 0,
      y: 20
    }} animate={{
      scale: 1,
      opacity: 1,
      y: 0
    }} exit={{
      scale: 0.9,
      opacity: 0,
      y: 20
    }} transition={{
      type: 'spring',
      damping: 25,
      stiffness: 300
    }} className="bg-brand-dark rounded-xl max-w-lg w-full max-h-[80vh] overflow-y-auto shadow-2xl border border-white/10" onClick={e => e.stopPropagation()} data-id="element-95">
        <div className="sticky top-0 bg-brand-dark border-b border-white/10 px-6 py-4 flex items-center justify-between rounded-t-xl" data-id="element-96">
          <h2 className="font-heading text-2xl text-white uppercase tracking-wide" data-id="element-97">
            {type === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
          </h2>
          <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-white/10 transition-colors text-slate-400 hover:text-white" data-id="element-98">
            <X size={18} data-id="element-99" />
          </button>
        </div>

        <div className="px-6 py-5 text-sm text-slate-400 leading-relaxed space-y-4" data-id="element-100">
          {type === 'privacy' ? <>
              <p className="text-slate-500 text-xs" data-id="element-101">
                Última actualización: Febrero 2026
              </p>

              <h3 className="font-semibold text-slate-200 text-base" data-id="element-102">
                1. Información que recopilamos
              </h3>
              <p data-id="element-103">
                Al realizar tu compra, recopilamos únicamente tu nombre y correo
                electrónico para enviarte el producto digital y comunicaciones
                relacionadas con tu compra.
              </p>

              <h3 className="font-semibold text-slate-200 text-base" data-id="element-104">
                2. Uso de la información
              </h3>
              <p data-id="element-105">Tu información se utiliza exclusivamente para:</p>
              <ul className="list-disc pl-5 space-y-1" data-id="element-106">
                <li data-id="element-107">Entregar el producto digital adquirido</li>
                <li data-id="element-108">Enviar confirmación de compra y recibo</li>
                <li data-id="element-109">Comunicar actualizaciones del producto (si aplica)</li>
                <li data-id="element-110">
                  Procesar solicitudes de reembolso dentro del período de
                  garantía
                </li>
              </ul>

              <h3 className="font-semibold text-slate-200 text-base" data-id="element-111">
                3. Protección de datos
              </h3>
              <p data-id="element-112">
                No vendemos, compartimos ni cedemos tu información personal a
                terceros. Los pagos son procesados de forma segura a través de
                plataformas de pago certificadas. No almacenamos datos de
                tarjetas de crédito.
              </p>

              <h3 className="font-semibold text-slate-200 text-base" data-id="element-113">
                4. Cookies
              </h3>
              <p data-id="element-114">
                Utilizamos cookies básicas para mejorar tu experiencia de
                navegación y analítica del sitio. No se utilizan cookies de
                seguimiento publicitario.
              </p>

              <h3 className="font-semibold text-slate-200 text-base" data-id="element-115">
                5. Tus derechos
              </h3>
              <p data-id="element-116">
                Puedes solicitar la eliminación de tus datos en cualquier
                momento. Al hacerlo, perderás acceso al producto digital
                adquirido.
              </p>
            </> : <>
              <p className="text-slate-500 text-xs" data-id="element-117">
                Última actualización: Febrero 2026
              </p>

              <h3 className="font-semibold text-slate-200 text-base" data-id="element-118">
                1. Producto digital
              </h3>
              <p data-id="element-119">
                "APAGA LA MENTE" es un producto digital descargable que incluye
                una guía en PDF y audios complementarios. El acceso se otorga de
                forma inmediata tras confirmar el pago.
              </p>

              <h3 className="font-semibold text-slate-200 text-base" data-id="element-120">
                2. Garantía de 7 días
              </h3>
              <p data-id="element-121">
                Ofrecemos una garantía de satisfacción de 7 días naturales a
                partir de la fecha de compra. Si el producto no cumple tus
                expectativas, puedes solicitar un reembolso completo dentro de
                este período sin necesidad de justificación.
              </p>

              <h3 className="font-semibold text-slate-200 text-base" data-id="element-122">
                3. Propiedad intelectual
              </h3>
              <p data-id="element-123">
                Todo el contenido del producto (textos, audios, diseños,
                sistema) es propiedad exclusiva de sus creadores. La compra
                otorga una licencia de uso personal e intransferible. Queda
                prohibida la reproducción, distribución o reventa del material.
              </p>

              <h3 className="font-semibold text-slate-200 text-base" data-id="element-124">
                4. Limitación de responsabilidad
              </h3>
              <p data-id="element-125">
                Los resultados pueden variar según el uso individual. El
                producto proporciona herramientas y un sistema de organización,
                pero no garantiza resultados específicos. No sustituye asesoría
                médica profesional.
              </p>

              <h3 className="font-semibold text-slate-200 text-base" data-id="element-126">
                5. Modificaciones
              </h3>
              <p data-id="element-127">
                Nos reservamos el derecho de actualizar estos términos. Los
                cambios no afectarán compras ya realizadas.
              </p>

              <h3 className="font-semibold text-slate-200 text-base" data-id="element-128">
                6. Aceptación
              </h3>
              <p data-id="element-129">
                Al realizar la compra, confirmas que has leído y aceptas estos
                términos y condiciones en su totalidad.
              </p>
            </>}
        </div>
      </motion.div>
    </motion.div>;
}
export function Footer() {
  const [modal, setModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-brand-dark py-8 px-4 border-t border-white/5" data-id="element-130">
        <div className="max-w-7xl mx-auto text-center space-y-3" data-id="element-131">
          <p className="text-slate-500 text-sm" data-id="element-132">
            © 2025 — APAGA LA MENTE | Protocolo de 14 Noches
          </p>
          <div className="flex items-center justify-center gap-4" data-id="element-133">
            <button onClick={() => setModal('privacy')} className="text-slate-600 text-xs hover:text-white transition-colors underline underline-offset-2" data-id="element-134">
              Política de Privacidad
            </button>
            <span className="text-slate-700 text-xs" data-id="element-135">·</span>
            <button onClick={() => setModal('terms')} className="text-slate-600 text-xs hover:text-white transition-colors underline underline-offset-2" data-id="element-136">
              Términos y Condiciones
            </button>
          </div>
          <p className="text-slate-600 text-[10px]" data-id="element-137">
            Producto digital · Acceso inmediato · Garantía de 7 días
          </p>
        </div>
      </footer>

      <AnimatePresence data-id="element-138">
        {modal && <LegalModal type={modal} onClose={() => setModal(null)} data-id="element-139" />}
      </AnimatePresence>
    </>;
}